import { fetchJsonResponse } from '@/ai/api'
import { trackEntitiesGenerated } from '@/utils/helpHero'
import { buildSingleEntityPrompt } from '@/ai/prompts'

export const generateSingleEntity = async ({
  workflow,
  cardTypes,
  name,
  entityDescription,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleEntityPrompt({
    workflow,
    cardTypes,
    name,
    entityDescription
  })

  const response = await fetchJsonResponse({
    messages,
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  trackEntitiesGenerated(response)

  return response || null
}
